<template>
  <div class="dialog-buy-top fix">
    <div class="dialog-buy-l">
      <img v-if="item.imageUrl" :src="item.imageUrl.split(',')[0]" :alt="item.productName"/>
      <img v-else src='../assets/no-picture.png' :title="item.productName"/>
    </div>
    <div class="dialog-buy-r">
      <h3 :title="item.productName">{{item.productName}}</h3>
      <div class="dialog-buy-label fix">
        <label v-if="item.status != 20 && item.auditStatus == 2 && item.stock != 0" class="d-ib"  :class="{'is-err': num > item.stock || item.stock == 0 }">库存{{item.stock}}{{item.saleUnit}}</label>

        <label v-if="item.auditStatus != 2 || item.status == 20 || item.stock == 0" class="sales-volumes">{{ item.auditStatus != 2 ? '已失效' : item.status == 20 ? '已下架' : item.stock == 0 ? '暂时缺货' : ''}}</label>

        <label v-if="item.status != 20 && item.auditStatus == 2 && item.stock != 0 && item.isLimited === '100' && item.remainedQuantity >= 0"  class="d-ib"  :class="{'is-err': num > item.remainedQuantity || item.remainedQuantity == 0 }">{{ '限购 ' + item.remainedQuantity + item.saleUnit }}</label>

      </div>
    </div>
    <template  v-if="item.status != 20 && item.auditStatus == 2 && item.stock > 0">
      <div class="c-price"><IconJifen size="mini" :points="item.price" /></div>
      <div class="c-input-num"><InputNum :tag="$route.name == 'product' ? 'product' : 'one'" :productCode="item.productCode" v-model="num" size="mini" :min="0" :max="999"/></div>
    </template>
  </div>
</template>

<script>
import InputNum from "./input-num";
import IconJifen from "./icon-jifen";
export default {
  name: "PItem",
  components: {
    InputNum,
    IconJifen
  },
  props: {
    item: {},
  },
  data() {
    return {
      num: this.item.quantity || 0
    };
  }
};
</script>

<style scoped>
.dialog-buy-l {
  float: left;
  width: 60px;
}
.dialog-buy-l img {
  width: 60px;
  height: 60px;
}
.dialog-buy-r {
  float: left;
  width: 400px;
  text-align: left;
  margin-left: 10px;
}
.dialog-buy-r h3 {
  font-size: 14px;
  line-height: 1.3;
  font-weight: inherit;
  max-height: 38px;
  overflow: hidden;
  color: #666;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  white-space: normal;
  word-break: break-all;
}
.dialog-buy-top {
  margin-top: 10px;
}
.dialog-buy-label {
  margin-top: 6px;
  color: #999;
}
.sales-volumes {
  margin-right: 10px;
  line-height: 18px;
  border-radius: 20px;
  padding: 3px 12px;
  font-size: 12px;
  color: #ff0000;
  background-color: #ffe5e5;
}
.c-input-num {
  margin-right: 10px;
  float: right;
}
.c-price {
  float: left;
  padding: 0 10px 0 6px;
  color: #ffcc00;
  font-size: 14px;
  line-height: 30px;
}
.c-price img {
  width: 20px;
  height: 20px;
  vertical-align: -5px;
  margin-right: 5px;
}
.d-ib {
  background-color: rgba(245, 245, 245, 1);
  color: #666;
  line-height: 18px;
  border-radius: 20px;
  padding: 3px 12px;
  font-size: 12px;
  margin-right: 10px;
}
.is-err {
  color: #ff0000;
  background-color: #ffe5e5;
}
</style>
